import React, { useState } from "react";
import PropTypes from "prop-types";
import { validateInput } from "../../library/utilities/Validator";
import { MultiSelect } from "react-multi-select-component";
import "../../css/common.css";
const MultiSelectCheckBox = ({
    className,
    options,
    value,
    onChange:change,
    labelledBy,
    Error,
    disabled,
    name,
    validators,
    getError
}) => {

    const [error, setError] = useState(false);
    const onChange = (val, labelName) => {
        if (validateInput(validators, val))
            setError(validateInput(validators, val));
        else if (!validateInput(validators, val) && value !== "") {
            setError(false);
        } else {
            setError(false);
        }
        change(val, labelName);
        getError &&
            getError(
                validateInput(validators, val) ? validateInput(validators, val) : false
            );
    };
    return (
        <>
            <div>
                {/* <Select 
                getOptionLabel={getOptionLabel}
                getOptionValue={getOptionValue}
                placeholder={placeholder}
                value={value}
                defaultValue={defaultValue}
                name={name}
                isDisabled={disabled}
                onChange={handleChange}
                options={options} 
                menuIsOpen={true}
                isMulti={isMulti}
            /> */}
                <MultiSelect
                    className={className}
                    options={options}
                    value={value}
                    onChange={onChange}
                    labelledBy={labelledBy}
                    isCreatable={true}
                    disabled={disabled}
                    
                />
            </div>
            {(error || Error && Error[name]) && <span className="text-danger errormsg ml-2">{error.message || Error[name]}</span>}

        </>
    );
};
MultiSelectCheckBox.propTypes = {
    label: PropTypes.string,
    onchange: PropTypes.func,
    labelClass: PropTypes.string,
    inputClass: PropTypes.string,
    placeholder: PropTypes.string,
};

MultiSelectCheckBox.defaultProps = {
    placeholder: "",
    label: "",
    labelClass: "col-md-4",
    inputClass: "col-md-4",
};

export default MultiSelectCheckBox;
